// extracted by mini-css-extract-plugin
export default {"subtitle":"styles_subtitle__iFvPH","buttons":"styles_buttons__UXjPH"};